import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from "react";
import { Button, Card, Grid, Icon, Table, Text } from "~/components-shared";
import styled from "styled-components";
import InsightsFindingTableRow from "~/components/InsightsFindingTableRow";
const StyledTableHeader = styled(Table.Header)`
  border-bottom: 1px solid ${_ref => {
  let {
    theme
  } = _ref;
  return theme.colors.borders.primary;
}};

  th {
    padding-bottom: 1em;
  }
`;
const InsightsFindingTable = _ref2 => {
  let {
    reportId,
    items,
    itemsPerPage = 3,
    heading,
    ...rest
  } = _ref2;
  const [page, setPage] = useState(1);
  const totalPageCount = Math.ceil(items.length / itemsPerPage);
  const paginatedItems = items.slice((page - 1) * itemsPerPage, page * itemsPerPage);
  if (!items.length) {
    return null;
  }
  const handleNextPageClick = () => {
    setPage(prev => prev + 1);
  };
  const handlePrevPageClick = () => {
    setPage(prev => prev - 1);
  };
  return /*#__PURE__*/React.createElement(Card, _extends({
    title: /*#__PURE__*/React.createElement(Grid, {
      cols: 2,
      template: "1fr auto auto auto",
      gap: 2,
      s: {
        px: 5,
        pt: 5
      },
      align: "center"
    }, /*#__PURE__*/React.createElement(Text, {
      element: "h3"
    }, heading), items.length > itemsPerPage && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
      onClick: handlePrevPageClick,
      color: "transparent",
      disabled: page === 1,
      s: {
        p: 1
      },
      outline: false,
      rounded: true
    }, /*#__PURE__*/React.createElement(Icon, {
      scale: 5,
      display: "block",
      rotate: -90,
      src: "chevron"
    })), /*#__PURE__*/React.createElement(Text, {
      weight: "medium",
      color: "textSecondary"
    }, page, " of ", totalPageCount), /*#__PURE__*/React.createElement(Button, {
      onClick: handleNextPageClick,
      color: "transparent",
      disabled: totalPageCount <= 1 || page >= totalPageCount,
      s: {
        p: 1
      },
      outline: false,
      rounded: true
    }, /*#__PURE__*/React.createElement(Icon, {
      scale: 5,
      display: "block",
      rotate: 90,
      src: "chevron"
    }))))
  }, rest), /*#__PURE__*/React.createElement(Table, {
    size: "m",
    fontSize: 3.2,
    tableProps: {
      style: {
        minWidth: "650px"
      }
    }
  }, /*#__PURE__*/React.createElement(StyledTableHeader, null, /*#__PURE__*/React.createElement(Table.Tr, null, /*#__PURE__*/React.createElement(Table.Th, {
    width: "0"
  }), /*#__PURE__*/React.createElement(Table.Th, {
    width: "180px"
  }, "Topic"), /*#__PURE__*/React.createElement(Table.Th, {
    width: "250px"
  }, "Details"), /*#__PURE__*/React.createElement(Table.Th, {
    width: "250px"
  }, "Action Items"), /*#__PURE__*/React.createElement(Table.Th, {
    width: "50px"
  }, "Impact"), /*#__PURE__*/React.createElement(Table.Th, {
    width: "130px"
  }, "Date detected"), /*#__PURE__*/React.createElement(Table.Th, {
    width: "70px"
  }, "Relevancy"), /*#__PURE__*/React.createElement(Table.Th, {
    width: "0"
  }))), /*#__PURE__*/React.createElement(Table.Body, null, paginatedItems.map(finding => /*#__PURE__*/React.createElement(InsightsFindingTableRow, {
    key: finding.id,
    reportId: reportId,
    finding: finding
  })))));
};
export default InsightsFindingTable;